export const zonesReducer = (state = {loading: false, resultzone: null, zones: [], zone: null, total: 0} , action) => {
    switch (action.type) {
        case 'ZONE_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                zones: action.payload.zones,
                total: action.payload.total
            }
        case 'ZONE_GETALLFORSELECT_SUCCESS':
            return {
                ...state,
                zonesForSelect: action.payload
            }
        case 'ZONE_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                zone: action.payload.zone
            }
        case 'ZONE_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultzone: action.payload.message,
                zone: action.payload.zone,
                zones: [...state.zones, action.payload.zone],
            }
        case 'ZONE_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultzone: action.payload.message
            }
        case 'ZONE_EDIT_SUCCESS':
            if(action.payload.zone){
                return {
                    ...state,
                    loading: false,
                    resultzone: action.payload.message,
                    zone: action.payload.zone,
                    zones: state.zones.map(zone => zone._id === action.payload.zone._id ? action.payload.zone : zone),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultzone: action.payload
                }
            }
        case 'ZONE_RESET_RESULT':
            return {
                ...state,
                resultzone: null
            }
        case 'ZONE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ZONE_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
